import axios from 'axios'
import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

class PosService {
  index(pageNumber: number, sortOrder: string, transactionFlowType: string | undefined) {
    return axios.get(
      `pos-transactions?page=${pageNumber}&sortOrder=${sortOrder}&transactionFlowType=${transactionFlowType}`,
    )
  }

  searchTransaction(
    endpoint: string,
    pageNumber: number,
    sortOrder: string,
    transactionFlowType: string | undefined,
  ) {
    return axios.get(
      `pos-transactions/search?${endpoint}&page=${pageNumber}&sortOrder=${sortOrder}&transactionFlowType=${transactionFlowType}`,
    )
  }

  exportTransaction(
    pageNumber: number,
    sortOrder: string,
    transactionFlowType: string | undefined,
  ) {
    return axios.get(
      `pos-transactions/export/csv?page=${pageNumber}&sortOrder=${sortOrder}&transactionFlowType=${transactionFlowType}`,
      {
        responseType: 'blob',
      },
    )
  }

  setPosTerminal(data: {
    msisdn: string
    posTerminalId: string
    provider: string
    authorizationCode: string
  }) {
    return axios.post('pos-transactions/set-pos-terminal', data)
  }

  async getAccountsWithPosTerminal(
    pageNumber: number,
    sortOrder: string,
    terminalId: string | undefined,
    from: string | undefined,
    to: string | undefined,
    posTerminalId: string | undefined,
    provider: string | undefined,
  ) {
    const providerParam =
      provider === undefined && provider !== 'ALL'
        ? terminalId === undefined
          ? ''
          : `&provider=${encodeURIComponent(terminalId)}`
        : `&provider=${encodeURIComponent(provider)}`

    const posTerminalIdParam =
      posTerminalId === undefined ? '' : `&posTerminalId=${encodeURIComponent(posTerminalId)}`

    const toParam = to === undefined ? '' : `&to=${encodeURIComponent(to)}`
    const fromParam = from === undefined ? '' : `&from=${encodeURIComponent(from)}`

    const queryParams = `pageNumber=${pageNumber ?? 1}&sortOrder=${encodeURIComponent(sortOrder)}${providerParam}${posTerminalIdParam}${toParam}${fromParam}`
    return await axios.get(`pos-transactions/accounts-with-pos-terminal/list?${queryParams}`)

    // return axios.get(
    //   `pos-transactions/accounts-with-pos-terminal/list?page=${pageNumber}&sortOrder=${sortOrder}&provider=${terminalId}`,
    // )
  }

  async getPosTransactions(
    pageNumber: number,
    sortOrder: string,
    terminalId: string | undefined,
    from: string | undefined,
    to: string | undefined,
    posTerminalId: string | undefined,
    provider: string | undefined,
  ) {
    const providerParam =
      provider === undefined && provider !== 'ALL'
        ? terminalId === undefined
          ? ''
          : `&provider=${encodeURIComponent(terminalId)}`
        : `&provider=${encodeURIComponent(provider)}`

    const posTerminalIdParam =
      posTerminalId === undefined ? '' : `&posTerminalId=${encodeURIComponent(posTerminalId)}`

    const toParam = to === undefined ? '' : `&to=${encodeURIComponent(to)}`
    const fromParam = from === undefined ? '' : `&from=${encodeURIComponent(from)}`

    const queryParams = `pageNumber=${pageNumber ?? 1}&sortOrder=${encodeURIComponent(sortOrder)}${providerParam}${posTerminalIdParam}${toParam}${fromParam}`
    return await axios.get(`/pos-transactions?${queryParams}`)
  }

  searchPosTransactions(
    endpoint: string,
    pageNumber: number,
    sortOrder: string,
    terminalId: string | undefined,
    from: string | undefined,
    to: string | undefined,
    posTerminalId: string | undefined,
    provider: string | undefined,
  ) {
    return axios.get(
      `pos-transactions/search?${endpoint}&page=${pageNumber}&sortOrder=${sortOrder}&provider=${terminalId}&from=${from}&to=${to}&posTerminalId=${posTerminalId}&provider=${provider}`,
    )
  }

  searchPosAccount(endpoint: string, pageNumber: number, sortOrder: string) {
    return axios.get(
      `pos-transactions/accounts-with-pos-terminal/list?${endpoint}&page=${pageNumber}&sortOrder=${sortOrder}`,
    )
  }

  async getPosTerminalTransactions(
    pageNumber: number,
    sortOrder: string,
    posTerminalId: string | undefined,
    to?: string | undefined,
    from?: string | undefined,
  ) {
    const posTerminalIdParam =
      posTerminalId === undefined ? '' : `&posTerminalId=${encodeURIComponent(posTerminalId)}`

    const posToParam = to === undefined ? '' : `&to=${encodeURIComponent(to)}`

    const posFromParam = from === undefined ? '' : `&from=${encodeURIComponent(from)}`

    const queryParams = `pageNumber=${pageNumber ?? 1}&sortOrder=${encodeURIComponent(sortOrder)}${posTerminalIdParam}${posToParam}${posFromParam}`
    return await axios.get(`/pos-transactions?${queryParams}`)
  }

  async exportPosTransactions(
    pageNumber: number,
    sortOrder: string,
    terminalId?: string,
    from?: string,
    to?: string,
    posTerminalId?: string,
    provider?: string,
  ) {
    const params = new URLSearchParams()

    params.append('page', pageNumber.toString())
    params.append('sortOrder', sortOrder)

    if (terminalId) {
      params.append('terminalId', terminalId)
    }

    if (from) {
      params.append('from', from)
    }

    if (to) {
      params.append('to', to)
    }

    if (posTerminalId) {
      params.append('posTerminalId', posTerminalId)
    }

    if (provider) {
      params.append('provider', provider)
    }

    return await axios.get(`pos-transactions/export/csv?${params.toString()}`, {
      responseType: 'blob',
    })
  }

  async deleteAccountPosTerminal(id: string) {
    return await axios.delete(`pos-transactions/account-pos-terminal/${id}`)
  }

  async updateAccountPosTerminal(id: string, data: { authorizationCode: string }) {
    return await axios.patch(`pos-transactions/account-pos-terminal/${id}`, data)
  }

  async terminalList(pageNumber: number, sortOrder: string, customerMsisdn: string | undefined) {
    return await axios.get(
      `/pos-transactions/accounts-with-pos-terminal/list?pageNumber=${pageNumber}&sortOrder=${sortOrder}&accountId=${customerMsisdn}`,
    )
  }
}

export default new PosService()
